// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__FTtE_","withMobileMargins":"DateRangeInput_withMobileMargins__40r7b","arrowIcon":"DateRangeInput_arrowIcon__1MmwL"};